module.exports = __webpack_public_path__ + "static/img/level3.b2955c01.png";